import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Tracking } from 'bdvp-tracking';
import { normalizeMediaItem, scrollRestore } from 'bdvp-common/src/utils';
import { useDictionary } from 'bdvp-common/src/hooks/config';
import Heading from 'bdvp-common/src/components/RowHeading';

import Hero from '../Hero';
import Template from '../Template';
import Carousels from '../Carousels';
import FeaturedVideo from '../FeaturedVideo';
import LineScore from '../LineScore';
import Decisions from '../Decisions';
import LazyInnings from '../LazyInnings';
import Head from '../Head';
import Notification from '../Notification';
import Story from '../Story';

const GameIndexPage = (props) => {

    const {
        loading,
        data,
        isEU,
        isPlaybackReady,
    } = props;

    const { summary = 'Summary' } = useDictionary();
    const mediaItem = useMemo(() => data ? normalizeMediaItem(data.mediaPlayback) : {}, [data]);

    useEffect(() => {

        scrollRestore();
        Tracking.trackGameIndexPageView();

    }, []);

    return (
        <>
            <Head data={data} mediaItem={mediaItem} loading={loading} />
            <Template
                notification={<Notification />}
                hero={<Hero loading={loading} data={data} />}
                headline={<Heading loading={loading} text={summary} />}
                player={<FeaturedVideo loading={loading} data={data} mediaItem={mediaItem} isEU={isEU} isPlaybackReady={isPlaybackReady} />}
                story={<Story loading={loading} data={data} />}
                linescore={<LineScore loading={loading} data={data} />}
                decisions={<Decisions loading={loading} data={data} />}
                carousels={<Carousels />}
                innings={<LazyInnings />}
            />
        </>
    );

};

GameIndexPage.propTypes = {
    loading: PropTypes.bool.isRequired,
    isPlaybackReady: PropTypes.bool.isRequired,
    data: PropTypes.object,
    isEU: PropTypes.bool,
};

GameIndexPage.defaultProps = {
    data: {},
    isEU: false,
};

export default GameIndexPage;
